import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Navigation from '../components/Navigation'

import 'prismjs/themes/prism-solarizedlight.css'
import './blog-post.scss'

export default ({ data }) => {
  const post = data.markdownRemark
  return (
    <div>
      <Navigation />
      <Helmet title={ post.frontmatter.title } />
      <div className="container" style={{ marginTop: '15px' }}>
        <div className="row">
          <div className="col-sm-12">
            <Link to="/blog">&lt;&lt; Back</Link>
            <img style={{ marginTop: '15px' }} src={ `/images/${post.frontmatter.featuredImage}` } />
            <h1>
              { post.frontmatter.title }
            </h1>
            <div className="post" dangerouslySetInnerHTML={{ __html: post.html }} />
          </div>
        </div>
      </div>
    </div>
  )
}

export const query = graphql`
query BlogPostQuery($slug: String!) {
  markdownRemark(fields: { slug: { eq: $slug } }) {
    html
    frontmatter {
      categories
      date(formatString: "MMMM DD, YYYY")
      featuredImage
      title
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/templates/blog-post.js